import React from 'react'
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { Topbar } from '../components/include/Topbar'
import StatCard from '../components/common/StatCard'
import { useSelector } from 'react-redux'
import { isPermission, isRole } from '../redux/selectors/authSelector'
import Error403Page from './ErrorPage'
import HttpService from '../helpers/httpServices'
import { Postdata } from '../helpers/api.service'
import bordIcon from '../assets/Icons/Vector (1).png'
import admissionIcon from '../assets/Icons/ID_Card.png'
import { useCountryNavigate } from '../components/common/UseCountryNavigate';
const Dashboard = () => {
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole)
  console.log("permissions", permissions)
  const isAccessible = role == "schooladmin" || permissions && permissions?.includes('view_Dashboard') || false;
  const [dashboard, setDashboard] = React.useState({});
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const handleNavigateToAdmissions = () => {
    navigate('admissions'); // Navigate to the admissions page
  }

  React.useEffect(() => {
    // Fetch dashboard data from API
    Postdata(HttpService.dashboard, {

    }).then((res) => {
      if (res.status === 200) {
        console.log('res.data: ', res.data);
        setDashboard({
          totalManagement: res.data.managementCount || 0,
          totalBoardManagement: res.data.boardManagementCount || 0,
          admissionCount: res.data.admissionCount || 0,
          admissionGuidelines: res.data.admissionGuidelines || [],
          school: res.data.school_name || 'School Name',
        });
      } else {

      }
    })
    // For demonstration, using static data


  }, []);


  if (!isAccessible) {
    return (
      <>
        <Error403Page />
      </>
    );
  }

  return (
    <>
      <Topbar title={dashboard.school} />
      <div className="p-6 space-y-6 pr-0">
        {/* Stat Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <StatCard color="#FDBA74" count={dashboard.totalManagement} icon={bordIcon} label="Total Number of Management People" />
          <StatCard color="#67E8F9" count={dashboard.totalBoardManagement} icon={bordIcon} label="Total Number of Board Management People" />
          <StatCard color="#A7F3D0" count={dashboard.admissionCount} icon={admissionIcon} label="Total Applications for Admission" />
        </div>

        {/* Admission Guidelines Section */}
        <div className="bg-white rounded p-6 shadow">
          <ul className="list-disc ml-5 space-y-1 text-sm">
            <h2 className="text-lg font-bold mb-2">Admission Guidelines</h2>
            {dashboard.admissionGuidelines && dashboard.admissionGuidelines.map((guideline, index) => (

              <li key={index}>
                <strong>{guideline.title}:</strong> {guideline.description}
              </li>
            ))}
            {/* etc */}
          </ul>
          <button
            className="mt-4 px-4 py-1 border-1 rounded-lg border-purple-700 text-purple-700 hover:bg-purple-50 w-full flex items-center justify-between"
            onClick={handleNavigateToAdmissions} // Add onClick event to navigate
          >
            <span className="">See Fees Structure</span>
            <span className="text-2xl"> &gt; </span>
          </button>
        </div>
      </div>
    </>
    // <div className='row'>
    //     <Title name='Dashboard' />
    //       <div className='col-lg-12'>
    //        <Tabs
    //       id="controlled-tab-example"
    //       className="tabs_title"
    //       // onSelect={handleSelect}
    //       activeKey={false}
    //     >
    //       <Tab title="Quick Links :" disabled className="quickLinks">
    //       </Tab>
    //     </Tabs>
    //       </div>
    //   </div>
  )
}

export default Dashboard;
